import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { RouterConstants } from '../../../../core/routing/constants/app-paths.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { OemService } from '../../../../core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Content } from '../../interface/oem-portal-interface.i';
import { Utils } from '../../../../../app/common/utils/utils';
import { first } from 'rxjs/internal/operators/first';
import { OemConstants } from '../../../../core/routing/services/oem/constants/oem.constants';


@Component({
  selector: 'iposcen-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {
  @Output() readonly viewOn = new EventEmitter();
  @Output() readonly emitEditData = new EventEmitter();
  @Input() contentId: string;
  @Input() autoID: string;
  contentData: any;
  systemModelData: string;
  parsedData: any;
  singleData: boolean;
  languages: any;
  language = new Map();
  languageList = [];
  image: any;
  displayLanguage: string;
  displayName: any;
  displayLanguageList = new Map();
  displayValueList = new Map();
  contentName: string;
  systemID: string;
  languageCategory: string;
  reviewStatus: string;
  displayVal = [];
  displayLang: any;
  displayList = [];
  private ngUnsubscribe = new Subject();
  assetID: string;
  configurations: any;
  englishLang = 'English - United States';
  chineseSimplified = 'Chinese - Simplified';
  chineseTraditional = 'Chinese - Traditional';
  disvalue: string;
  comments: string;
  hasComments: boolean = false;
  contentGroupPages = [];
  operatingSystem: any;


  constructor(private router: Router, private oemservice: OemService) { }

  ngOnInit(): void {
    this.getContentData();
  }

  getContentData() {
    this.oemservice.getContentDatabyContentID(this.autoID, this.contentId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllContentResponse => {
        this.contentData = getAllContentResponse.content as Content[];
        this.contentName = this.contentData.contentName;
        this.systemID = this.contentData.systemID;
        this.languageCategory = this.contentData.languageCategory;
        this.reviewStatus = this.contentData.reviewStatus;
        this.configurations = this.contentData.configurations;
        this.autoID = this.contentData.autoID;
        this.comments = this.contentData.comments;
        this.operatingSystem = getAllContentResponse.content.operatingSystem.replaceAll(',', ', ');

        if (this.comments && this.comments !== ' ') {
          this.hasComments = true;
        } else {
          this.hasComments = false;
        }


        this.configurations = JSON.parse(this.contentData.configurations);
        this.contentGroupPages.push(this.configurations.contentGroupPages);
        this.assetID = this.configurations.assetID; 
        this.getThumnailByAutoId();
        try {

          this.displayName = JSON.parse(getAllContentResponse.content.displayName);
          Object.keys(this.displayName).forEach((value, index) => {
            let arr;
            this.displayLanguageList.set(index, this.getLanguageByCode(value));
            arr = Array.from(this.displayLanguageList.values());
            this.displayLang = arr;
            
          })
          Object.values(this.displayName).forEach((value, index) => {
            let arr;
            this.displayValueList.set(index, value);
            arr = Array.from(this.displayValueList.values());
            this.displayVal = arr;
          });
        } catch {
          this.disvalue = getAllContentResponse.content.displayName;
        }
        this.languages = getAllContentResponse.content.languages;
        try {
          this.languages = JSON.parse(this.languages);
          this.languages.forEach((data, index) => {
            this.language.set(index, this.getLanguageByCodeIn(data));
          })
          this.languageList = Array.from(this.language.values());
          this.displayLanguage = this.languageList.join(', ');
        } catch {
          this.displayLanguage = getAllContentResponse.content.languages;
        }
        this.systemModelData = getAllContentResponse.content.systemModels;
        try {
          this.parsedData = JSON.parse(this.systemModelData);
          this.singleData = false;
        } catch {
          this.parsedData = getAllContentResponse.content.systemModels;
          this.singleData = true;
        }
      })
  }

  getLanguageByCode(langCode) {
    return Utils.decodeLanguageByCodeout(langCode);
  }
  getLanguageByCodeIn(langCode){
    if(langCode === 'zh-cn'){
      return this.chineseSimplified
    } else if(langCode === 'zh-tw'){
      return this.chineseTraditional
    } else{
      return Utils.decodeLanguageByCodeIn(langCode)
    }
   
  }


  getThumnailByAutoId() {
    const reader = new FileReader();
    this.oemservice.getAssetByAutoIdAndAssetIdView(this.assetID, OemConstants.SLASH_THUMBNAIL, this.autoID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(imageData => {
        reader.addEventListener('load', () => {
          this.image = reader.result;
        }, false);
        if (imageData) {
          reader.readAsDataURL(imageData);
        }
      },
        error => {
          // do something
        });
  }


  goBack() {
    this.viewOn.emit(false);
  }

  goEdit() { 
    this.emitEditData.emit([this.contentData,1]);
    this.goBack(); 
  }

}
